"use client";

import type { ReactNode } from "react";
import type { CurrentUser } from "./types";

export interface TopbarProps {
  title?: ReactNode;
  onToggleSidebar?: () => void;
  collapsed?: boolean;
  user?: CurrentUser;
  actions?: ReactNode;
}

export function Topbar({ title, onToggleSidebar, collapsed, user, actions }: TopbarProps) {
  return (
    <header className="cui-shell-topbar">
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {onToggleSidebar && (
          <button
            type="button"
            className="cui-shell-collapse-btn"
            onClick={onToggleSidebar}
            aria-label={collapsed ? "展開側欄" : "收合側欄"}
          >
            ☰
          </button>
        )}
        {/* 頂欄標題是「你在哪」的次要資訊。原本 14px/600 主色，與頁面 H1（20px/700）
            爭視覺主導權；改為 muted 小字，讓 H1 明確是頁面的第一層級。 */}
        {title && <div className="cui-shell-crumb">{title}</div>}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {actions}
        {user && (
          <div className="cui-shell-user">
            <span className="cui-shell-avatar">{(user.avatarText ?? user.name.slice(0, 1)).toUpperCase()}</span>
            {/*
              兩行堆疊：Super Administrator 這類長角色名在單行時會把使用者名擠掉。
              B2 第 2 輪②（高-1）：改用 class（cui-shell-user-meta/-name）而非 inline
              style，讓 styles.ts 能對帳號這種不可斷詞字串做 min-width:0 + ellipsis，
              390 寬真實載入才不會把 Topbar 撐爆、造成 body 橫向捲動。見 styles.ts
              .cui-shell-user-meta 註解／規範 §6.4。
            */}
            <span className="cui-shell-user-meta">
              <span className="cui-shell-user-name">{user.name}</span>
              {user.role && <span className="cui-shell-user-role">{user.role}</span>}
            </span>
          </div>
        )}
      </div>
    </header>
  );
}
